
      <div class="col-md-12">
        <div class="form-group">
          <label for="class_name">Overview<span class="required"></span></label>
          <ckeditor [config]="config_ck" >

          </ckeditor>
        </div>
      </div>
